import { takeUntil, tap } from 'rxjs/operators';
import { Directive, ElementRef, Renderer2, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';

@Directive({
    selector: '[EventOnChildren]',
})
export class EventOnChildrenDirective implements OnInit, OnDestroy {

    @Output() EventEmitter = new EventEmitter();
    @Input() event: string;
    @Input() enabled = true;
    @Input() parent;
    @Input() excludeParent = false;


    private destroy$ = new Subject<void>();

    constructor(private _el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {
        if (this.parent === 'blocksvideo') {
            const event$ = fromEvent(document, this.event);
            event$.pipe(
                tap((ev: any) => {
                    if (this._el.nativeElement.contains(ev.target) || ev.target == this._el.nativeElement) {
                        this.EventEmitter.emit(true);
                    } else {
                        this.EventEmitter.emit(false);
                        
                    }
                }),
                takeUntil(this.destroy$)
    
            ).subscribe();
        } else if (this.excludeParent) {
            const event2$ = fromEvent(document, this.event)
            event2$.pipe(
                tap((ev: any) => {
                    if (ev.target == this._el.nativeElement) {
                        this.EventEmitter.emit(false);
                    } else {
                        this.EventEmitter.emit(false);
                        
                    }
                }),
                takeUntil(this.destroy$))
        } else {
            this.renderer.listen(document, this.event, (ev) => {
                if (!this._el.nativeElement.contains(ev.target) || ev.target == this._el.nativeElement) {
                    this.EventEmitter.emit(false);
    
                } else {
                    this.EventEmitter.emit(true);
                }
            });

        }
       
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
}
